import React from 'react'
import '../css/Home.css'
 function Home() {
  return (
    <div class="home vh-100 " id="home" >
   <div class=" p-3 ">
   <div class='row  h-100  '>
      <div class=" col-lg-6 col-md-12 col-sm-12  d-flex  justify-content-center align-items-center " data-aos="fade-up"  data-aos-easing="ease-out-cubic"
     data-aos-duration="1500">
      <div class=" ms-3"> 
      <h6  class="py-3 text-dark">EMPOWER YOUR BUSSINESS  </h6>
      <p  class="py-3 text-dark"> Excellent IT Services <br/> For Your Success</p>
      </div>
          
      </div>
      <div class=" col-lg-6 col-md-12 col-sm-12  d-flex  justify-content-center align-items-center">
        <div class=" d-flex ">
        <img src="/assets/home5.png " class=" img-service  img-fluid  " alt="test image"   /> 
        </div>
      </div>
    </div>
   </div>
  </div> 
    
  )
}

export default Home;